"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _airbnbPropTypes = require("airbnb-prop-types");
var _propTypes = require("prop-types");
var _propTypes2 = require("@agillic/prop-types");
var _icon = _interopRequireDefault(require("../icon/icon.presenter"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var handleStarClick = function handleStarClick(_ref) {
  var isDisabled = _ref.isDisabled,
    isReadOnly = _ref.isReadOnly,
    onSelect = _ref.onSelect,
    starsSelected = _ref.starsSelected;
  return !isDisabled && !isReadOnly && onSelect(starsSelected);
};
var starWidth = 32;
var smallIndex = 0.7;
var StarRating = function StarRating(_ref2) {
  var rating = _ref2.rating,
    total = _ref2.total,
    isDisabled = _ref2.isDisabled,
    label = _ref2.label,
    isSmall = _ref2.isSmall,
    starColor = _ref2.starColor,
    onSelect = _ref2.onSelect,
    tooltip = _ref2.tooltip,
    isReadOnly = _ref2.isReadOnly,
    uniqueID = _ref2.uniqueID;
  return _react.default.createElement("div", {
    className: (0, _classnames.default)('agillicStarRating', {
      small: isSmall
    }),
    title: tooltip,
    "data-testid": uniqueID
  }, label && _react.default.createElement("label", null, label), _react.default.createElement("div", {
    className: (0, _classnames.default)('buttonWrapper', starColor, {
      disabled: isDisabled,
      readOnly: isReadOnly
    }),
    style: {
      width: "".concat(starWidth * total * (isSmall ? smallIndex : 1))
    }
  }, Array(rating).fill().map(function (_, index) {
    return _react.default.createElement("button", {
      className: "starSelected",
      key: "".concat(index + 1, "starsSelected"),
      style: {
        width: "".concat(starWidth * (isSmall ? smallIndex : 1))
      },
      onClick: function onClick() {
        return handleStarClick({
          isDisabled: isDisabled,
          isReadOnly: isReadOnly,
          onSelect: onSelect,
          starsSelected: index + 1
        });
      },
      "data-testid": "star".concat(index + 1)
    }, _react.default.createElement(_icon.default, {
      name: "star",
      namespace: "fas"
    }));
  }), Array(total - rating).fill().map(function (_, index) {
    return _react.default.createElement("button", {
      className: "total",
      key: "".concat(rating + index + 1, "starsSelected"),
      style: {
        width: "".concat(starWidth * (isSmall ? smallIndex : 1))
      },
      onClick: function onClick() {
        return handleStarClick({
          isDisabled: isDisabled,
          isReadOnly: isReadOnly,
          onSelect: onSelect,
          starsSelected: rating + index + 1
        });
      },
      "data-testid": "star".concat(rating + index + 1)
    }, _react.default.createElement(_icon.default, {
      name: "star",
      namespace: "fas"
    }));
  })));
};
StarRating.propTypes = {
  onSelect: _propTypes.func.isRequired,
  uniqueID: _propTypes.string,
  rating: _propTypes.number.isRequired,
  total: (0, _airbnbPropTypes.and)([_propTypes.number, (0, _propTypes2.greaterThan)('rating')]),
  isReadOnly: _propTypes.bool,
  isDisabled: (0, _airbnbPropTypes.and)([_propTypes.bool, (0, _propTypes2.forbiddenBy)('readOnly')]),
  label: _propTypes.string,
  tooltip: _propTypes.string,
  isSmall: _propTypes.bool,
  starColor: (0, _propTypes.oneOf)(['grey', 'red', 'green', 'lightGreen', 'blue', 'orange', 'darkOrange', 'purple', 'yellow']).isRequired
};
StarRating.defaultProps = {
  starColor: 'darkOrange',
  total: 5
};
var _default = StarRating;
exports.default = _default;